import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantSignUpService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_ParticipantSignUp_ParticipantInformationForSignUpDto,
} from '../../services/wealthlane-customer-services';
import { useSelector } from 'react-redux';
import { selectTenantId } from '../../pages/configuration/participantSignupSlice';

const useGetSignUpInformation = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  token: string | null
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_ParticipantSignUp_ParticipantInformationForSignUpDto | undefined,
  unknown
> => {
  const id = useSelector(selectTenantId);
  const participantSignUpInformation = useQuery(
    ['getSignUpInformation', token, id],
    async () => {
      if (token != null && id !== null) {
        return await handleRequest(
          ParticipantSignUpService.getApiCustomerApiAppParticipantSignUpParticipantInformationForSignUp()
        );
      }
    },
    {
      enabled:
        typeof token === 'string' && token != null && token !== '' && id != null && id !== '',
    }
  );

  return participantSignUpInformation;
};

export default useGetSignUpInformation;
